module.exports = __webpack_public_path__ + "static/media/Landing_Imagen_Poster1.7b75bb3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/authentication/components/LandingTelmex/Landing_Imagen_Poster1.jpg
// module id = 1765
// module chunks = 0